/*
  background.js — Edible Growth Shopify Theme
  Direct port of src/components/GlobalBackground.jsx to vanilla JS.

  Runs a canvas-based particle/network animation as a fixed full-screen
  backdrop, plus floating leaf image overlays. No framework dependency.
*/

(function () {
  'use strict';

  /* ── CONFIGURATION (matches BG_CONFIG in GlobalBackground.jsx) ── */
  var BG_CONFIG = {
    particleDensity:       0.00007,
    particleSpeedMultiplier: 0.15,
    lineDistance:          110,
    colors: ['#3b82f6', '#10b981', '#a855f7'],
  };

  var LEAF_IMAGES = [
    'https://horizons-cdn.hostinger.com/2efe5464-c6e2-4d44-9105-a8ac028d7d46/a918b1f8bd92a126fe6cb4d418426410.png',
    'https://horizons-cdn.hostinger.com/2efe5464-c6e2-4d44-9105-a8ac028d7d46/55ac0cda055581385ebf3375a3313e81.png',
    'https://horizons-cdn.hostinger.com/2efe5464-c6e2-4d44-9105-a8ac028d7d46/d9a9fc4033b24943385210fb5667525b.png',
    'https://horizons-cdn.hostinger.com/2efe5464-c6e2-4d44-9105-a8ac028d7d46/45e6b72dd820d0a0ff6d17ee26e1e556.png',
  ];

  /* ── STATE ────────────────────────────────────────────────────── */
  var canvas, ctx;
  var rafId = null;
  var state = {
    width:     0,
    height:    0,
    particles: [],
    resizeTimer: null,
  };

  function random(min, max) {
    return Math.random() * (max - min) + min;
  }

  /* ── PARTICLES ────────────────────────────────────────────────── */
  function initScene() {
    if (!canvas) return;

    var dpr = window.devicePixelRatio || 1;
    var w   = window.innerWidth;
    var h   = window.innerHeight;

    canvas.width  = w * dpr;
    canvas.height = h * dpr;
    canvas.style.width  = '100vw';
    canvas.style.height = '100vh';

    ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    state.width  = w;
    state.height = h;

    var count = Math.floor(w * h * BG_CONFIG.particleDensity);
    state.particles = [];

    for (var i = 0; i < count; i++) {
      state.particles.push({
        x:          random(0, w),
        y:          random(0, h),
        baseSize:   random(1.5, 3),
        size:       0,
        pulseAngle: random(0, Math.PI * 2),
        pulseSpeed: random(0.005, 0.015),
        color:      BG_CONFIG.colors[Math.floor(random(0, BG_CONFIG.colors.length))],
        vx: random(-0.4, 0.4) * BG_CONFIG.particleSpeedMultiplier,
        vy: random(-0.4, 0.4) * BG_CONFIG.particleSpeedMultiplier,
      });
    }
  }

  function animate() {
    if (!canvas || !ctx) return;

    var w = state.width;
    var h = state.height;
    var ps = state.particles;

    ctx.clearRect(0, 0, w, h);
    ctx.lineWidth = 0.5;

    for (var i = 0; i < ps.length; i++) {
      var p1 = ps[i];

      p1.x += p1.vx;
      p1.y += p1.vy;

      p1.pulseAngle += p1.pulseSpeed;
      var scale = 1 + (((Math.sin(p1.pulseAngle) + 1) / 2) * 0.5);
      p1.size = p1.baseSize * scale;

      if (p1.x < 0 || p1.x > w) p1.vx *= -1;
      if (p1.y < 0 || p1.y > h) p1.vy *= -1;

      var maxDistSq = BG_CONFIG.lineDistance * BG_CONFIG.lineDistance;

      for (var j = i + 1; j < ps.length; j++) {
        var p2 = ps[j];
        var dx = p1.x - p2.x;
        var dy = p1.y - p2.y;
        var distSq = dx * dx + dy * dy;

        if (distSq < maxDistSq) {
          var opacity = Math.pow(1 - (distSq / maxDistSq), 1.8);
          var alphaHex = Math.floor(opacity * 200).toString(16).padStart(2, '0');

          var grad = ctx.createLinearGradient(p1.x, p1.y, p2.x, p2.y);
          grad.addColorStop(0, p1.color + alphaHex);
          grad.addColorStop(1, p2.color + alphaHex);

          ctx.strokeStyle = grad;
          ctx.beginPath();
          ctx.moveTo(p1.x, p1.y);
          ctx.lineTo(p2.x, p2.y);
          ctx.stroke();
        }
      }

      ctx.fillStyle   = p1.color;
      ctx.shadowBlur  = 8;
      ctx.shadowColor = p1.color;
      ctx.beginPath();
      ctx.arc(p1.x, p1.y, p1.size, 0, Math.PI * 2);
      ctx.fill();
      ctx.shadowBlur = 0;
    }

    rafId = requestAnimationFrame(animate);
  }

  /* ── LEAVES ───────────────────────────────────────────────────── */
  function initLeaves(container) {
    var leafCount = Math.min(Math.max(Math.floor(window.innerWidth / 400) + 3, 5), 8);

    for (var i = 0; i < leafCount; i++) {
      var size         = Math.random() * 150 + 150;
      var top          = Math.random() * 100;
      var left         = Math.random() * 100;
      var baseRotation = Math.random() * 360;
      var opacity      = Math.random() * 0.2 + 0.2;
      var animClass    = 'animate-leaf-' + ((i % 3) + 1);
      var src          = LEAF_IMAGES[i % LEAF_IMAGES.length];

      var wrap = document.createElement('div');
      wrap.className = 'eg-leaf ' + animClass;
      wrap.style.cssText = [
        'top:'    + top  + '%',
        'left:'   + left + '%',
        'width:'  + size + 'px',
        'height:' + size + 'px',
        'opacity:'+ opacity,
      ].join(';');

      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.style.transform = 'rotate(' + baseRotation + 'deg)';

      wrap.appendChild(img);
      container.appendChild(wrap);
    }
  }

  /* ── INIT ─────────────────────────────────────────────────────── */
  function init() {
    var bgEl      = document.getElementById('eg-global-bg');
    var leavesEl  = document.getElementById('eg-leaves-layer');

    if (!bgEl || !leavesEl) return;

    canvas = bgEl.querySelector('canvas');
    if (!canvas) {
      canvas = document.createElement('canvas');
      bgEl.insertBefore(canvas, leavesEl);
    }

    initScene();
    rafId = requestAnimationFrame(animate);
    initLeaves(leavesEl);

    window.addEventListener('resize', function () {
      clearTimeout(state.resizeTimer);
      state.resizeTimer = setTimeout(initScene, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
